
import { IMaskComponent } from 'vue-imask';
import VueTypes from 'vue-types';
import connectTelInput from '~/mixins/connect-tel-input';

export default {
    mixins: [connectTelInput],
    name: 'MyInputEcom',
    props: {
        value: VueTypes.oneOfType([String, Object, Number]).def(''),
        placeholder: VueTypes.oneOfType([String, Number]).def(''),
        label: VueTypes.string.def(''),

        type: VueTypes.string.def('text'),
        errorText: VueTypes.oneOfType([String, Array]).def('error'),

        readonly: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
        isRequired: VueTypes.bool.def(false),
        isUnvalid: VueTypes.bool.def(false),
    },
    components: {
        'imask-input': IMaskComponent,
    },
    computed: {
        mask() {
            if (this.$pocketSettings.isRomania) return '+4\\0-00 000 0000';
            else return '+(373)-#00-00-000';
        },
        placeholderMask() {
            if (this.placeholder) return this.placeholder;
            if (this.$pocketSettings.isRomania) return '+40-00 000 0000';
            else return '+(373)-#00-00-000';
        },
    },
    methods: {
        updateInput(e) {
            if (this.type === 'tel') {
                if (this.$pocketSettings.isRomania) {
                    if (e) {
                        if (!e.includes('+40-')) {
                            const input = document.getElementById('imask-input-tel');

                            this.$emit('input', '+40-' + e.slice(-1));
                            setTimeout(() => {
                                input.setSelectionRange(('+40-' + e.slice(-1)).length, ('+40-' + e.slice(-1)).length);
                            }, 25);
                        } else {
                            this.$emit('input', e);
                        }
                    }
                } else {
                    if (e) {
                        if (!e.includes('+(373)-')) {
                            const input = document.getElementById('imask-input-tel');

                            this.$emit('input', '+(373)-' + e.slice(-1));
                            setTimeout(() => {
                                input.setSelectionRange(('+(373)-' + e.slice(-1)).length, ('+(373)-' + e.slice(-1)).length);
                            }, 25);
                        } else {
                            this.$emit('input', e);
                        }
                    }
                }
            } else {
                this.$emit('input', e.target.value);
            }
        },
    },
};
